const coins = [
	10,
	1,
	0.5
]

export default coins;